const JosenAllReleasesStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3g84iSHpzN7UwVHbCDyROM?si=08a3313a666e4b71" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-HnXwvyVUppgOvdvH-ZzcIBw-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>FDB2T</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/658LhYRoD2v3cTsHSSmO3u?si=7eaa543734ff4a8e" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-vysq6TCvGjfQvuZC-0drVIg-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>SCAT</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4njdauy20lpQiw59xKS37e?si=a69864f4d5774a29" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-wmjtQYXBp4e9tsfl-ybcmoQ-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>HAT 2 DA SIDE</strong><br/>
                (prod. Lux)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/iaintpassindarock-prodapt9" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-uLlBQeIAi7h8x9XM-PhiwlA-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>iAiNTPASSiNDAROCK</strong><br/>
                (prod. Apartment9)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/datdeuce-w-rich-illuminati-1" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-YfmfaLZdNiBk54CE-4h7z8g-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>DATDEUCE</strong><br/>
                (prod. Rich illuminati & notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/7CvLjJHILCFyv2IB5BsLkl?si=e783fa2bfc0d4fe35qI" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-L1I7F2FWrhohq6E8-v5KyIA-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>GLOCK40</strong><br/>
                (prod. Apartment9)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2vbtk5pNS6jIKTGPHW0vhD?si=6e259d06b9194cce" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-jpL7JnHJqStndI65-qXPfhQ-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>TAKEAHIT</strong><br/>
                (prod. Lux)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/doubledown-josenfriday" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-s5Dc6eJCNavTf1kf-uJ5pXg-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>DOUBLEDOWN</strong><br/>
                (prod. meauxminy)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/2doe-freestyle-prodnotamachine" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-HSvA1cca3yC3ntOG-CWLyZA-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>2DOE FREESTYLE</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2geGtAhq095Ju7S1dvahgc?si=5d877f5992a4487d" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-YaBKpyr2oqVloygn-ph5rrg-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>BIG JURRASIK</strong><br/>
                (prod. Dani, bbuggin & Citgo)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/7alpJm7b624gooBFH3VLG5?si=a977d9aefdba4790" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d0000b27377bb2cb501d97ec502be098d" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>BALENCi22</strong><br/>
                (prod. Geist)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0MU8Umg5vwONt6d2rpavyz?si=63f3fabeeff84ef0" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d0000b273b7dee890df982662cf13e888" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>ACTIVATE</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/greendot-24khris-josenfriday" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-jPlPR2pZso29uTzl-ji0QXQ-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>🟢GREENDOT🟢</strong><br/>
                (prod. 24KHRIS)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1w6kMjL8FGvmFVXCT0WL8T?si=ad09b28a2cf845c0" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e023fd21cc66edb0472674a6007" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>GLOCK HIT LIKE DA INTERVENTION</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0cjRt5b9VnhatXJAd0z3Zj?si=fdada77113ef4e7d" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02278d62cd221ead6dfc221f81" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>ON MY OWN</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/44qNSRzwLplgOIxTcHezTj?si=f0918acd5c8944bd" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0279ee2962c723396ed5f7692e" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>KOKAINE (feat. POPSTARBILLS)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2BLUOaAUNOZC4pbmw0iwrL?si=43262d0592a94a7d" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02b9ff17fcd530916999d819a6" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>WAKEUPDENiGEEK</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1uGi1orzJC8zQd9mctQsDO?si=5fc7e6dedead4633" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02c4e673ca86f4e2a6c5eeb91a" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>ROADRUNNAH</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5Qia5WzcW3vZCrSG5YRE3r?si=11a0339bd418413e" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02a75614b6f019ee8bcb1f13ab" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>LETDAPHONERiNG</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6TlGO1N7o6fDPi33JlRGRR?si=afc0586c5e48475c" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0235c369908d2d27353d745088" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>DRILLBOWSKI</strong><br/>
                (prod. notamachine & Rich Illuminati)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/dont-wipe-ya-nose-w-luvrei-slime" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-WB3yoKXwNsJtzcgd-LiYfUA-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>#DONT #WIPE #YA #NOSE (feat. LUVREI)</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1fBcPFnWwW1IwgauSc2U95?si=aeeb60dfb3824727" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02655f51d7a07be7d226346106" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>JUMP IN DAT WATER LIKE A DOLPHIN</strong><br/>
                (prod. Toju)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/iwalkindisbitchlikeimericdoa" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-wNs6XIflN1ISzLma-nBoqRA-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>IWALKINDISBITCHLIKEIMERICDOA</strong><br/>
                (prod. THEYLUVFLARE)
              </p>
            </a>
          </div>
          
          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/denzelle-prod-astral-trap-real" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-CzeiXhnZTRcjsrbz-Z5I8zA-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>DenZelle</strong><br/>
                (prod. Astral Trap)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/i-had-a-long-day-i-tell-a" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-i5NoiuyidghQkhhm-q4kVFw-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>I HAD A LONG DAY I TELL A NIGGA TO STFU</strong><br/>
                (prod. Taurs, Glokmane & Skreer)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/paid2much-w-destiny" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-dy0d03mtsQ01jEtY-Psx9Qg-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>PAID2MUCH (feat. DESTINY)</strong><br/>
                (prod. dead2finesse)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/g17-w-otakugod-prod" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e024c323c84146da484a1d3a5b7" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>G17 (feat. Otaku God)</strong><br/>
                (prod. Rich Illuminati)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1mwaKzNhv87dwW4ICSXeBn?si=d58a2351cc454cda" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02f268eb8eeb655ea03454b17d" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>POKEMON ZAZA LEGENDS FREESTYLE</strong><br/>
                (prod. Rich Illuminati)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0NXPj10xvnUPRYggfaa9Q4?si=a80dde6ad34e49b3" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e025eb448b3026f508985ec9344" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>SUPERBAD LIKE MCLOViN2</strong><br/>
                (prod. QueueUpNext & 1brite)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/4HpXDdjsCepoVmWt7LJLyv?si=93717e5dacba4466" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02eac330ad37d0953d938a76ab" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Gothnormie - NEMATODES (feat. Josen)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5Uv91ngmsGqtubjLO3FZBu?si=437331e07f7f41da" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-qmxouomUQqiB2OVS-9h281g-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>JELLO</strong><br/>
                (prod. Rich Illuminati)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/how-many-gangstas-1-2-3-4-prod" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-y6F8YsxovEHcPGiM-3cGKMg-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>HOW🤫 MANY 🤫GANGSTAS?!🤫 [1️⃣2️⃣3️⃣4️⃣]</strong><br/>
                (prod. Brwnworld)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/album/1Ie8taGbliNQ9e9mtwwk3E?si=RPHZ8aPGSE-fASx9P-JWiA" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-yGml62ovqVUxzl66-BWizbQ-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>KIRBY 2024 FREESTYLE</strong><br/>
                (prod. Prblm)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/5TgdN44gvyBk53GGTYjJBn?si=4777b42b513b4162" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e024506286616ec54ad77c41d32" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Ivanko - Hottest (feat. Josen)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4IgTDzUKbfqyHkFnD4kdm5?si=ae4bc26dc6674966" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02335be31b0e496f99c27ad014" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Plug Special</strong><br/>
                (prod. Apartment9)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2S4Sdrt9tm2sd2ONPnBDg8?si=8437214907d8438d" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02335be31b0e496f99c27ad014" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Actin Up</strong><br/>
                (prod. Baredex & Apartment9)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1XUMp7muPPMbYHoW1YbwD5?si=008a795de1e44d75" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02335be31b0e496f99c27ad014" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Crash out</strong><br/>
                (prod. Negative)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5NIMRwqwAcbRgv9lFRkjgm?si=a889f740bfef4264" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02335be31b0e496f99c27ad014" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Drizzy Drill Rogers (feat. xellfromhell)</strong><br/>
                (prod. Geeohhs)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0jCCmoYtZITtVJg2rBUTqN?si=99f5d7078c824f26" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02335be31b0e496f99c27ad014" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Miles Morales (feat. Lil Xelly)</strong><br/>
                (prod. Killguap)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0wo2pPJE1OQnnmuZ5ODkzo?si=4b60580ddbfa4c78" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02335be31b0e496f99c27ad014" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>WalkedInDisBitch (feat. RX Papi)</strong><br/>
                (prod. Snoopo)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4iaboFPV5eYXnI25jnyc8r?si=6338cef6eb8c4425" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02335be31b0e496f99c27ad014" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>PopOutDaKut</strong><br/>
                (prod. Negative)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0nThr5XVpjMFA6CO0SC55w?si=663eff02ddc54e74" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02335be31b0e496f99c27ad014" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Let My Denim Sag</strong><br/>
                (prod. Negative)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2JoFm05c3wrdzBf3l6UJ9a?si=bbfdb10bf9c1413d" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02335be31b0e496f99c27ad014" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Plug Dreamin</strong><br/>
                (prod. Apartment9)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2oFvSGs2gNK0zycCTRCOKR?si=ca62898aec604487" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02335be31b0e496f99c27ad014" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>No Bluff</strong><br/>
                (prod. QueueUpNext)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2BHzIPx75bm9jxf3QIHGr6?si=79b9c589397a40c4" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02335be31b0e496f99c27ad014" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>OGlockyAutoPartz</strong><br/>
                (prod. Rich Illuminati)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2xGiVCDwrHEIuQXdf2nqZf?si=3068da7d83dc4ba3" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02335be31b0e496f99c27ad014" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Peja Stojakvic (feat. Zazbourne)</strong><br/>
                (prod. Esse Got Heat)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4ihrjYQ7ap5rnIjaAVEcT2?si=efe52dddb31a415c" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02335be31b0e496f99c27ad014" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>IWALKINTHISBITCHLIKEIMICESPICE</strong><br/>
                (prod. QueueUpNext & Gemstone)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0EI2srekSk5Ax26LRYOaCV?si=60968963ccc84ee0" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0283d2584c7e1db29782851b70" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>PROJEKTBABY 2024</strong><br/>
                (prod. QueueUpNext)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/53cqq78Eq6epvDayi0a85w?si=e669dd6e01684a63" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0224dd874a1fa5b72bd19d431f" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>BOOMIN IN MIAMI</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0EETIPEvo4zq7a2TtwkBfz?si=4a97dbcd79a44cc0" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02d23f01076a9b53e9b31548a2" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>200 DYCKMAN 2 MIAMI (feat. Loudpack Kap)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5U0G2BnlS3xdbQsDX7KRhM?si=4b1eb1529ee440a1" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02fdd791b4824ae41ad682a6bb" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>MY DRAWZ!</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0AV2J2EN6aGz7emcDq36VK?si=c426c50aa2d74250" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02df75db3099fe8bfc0c55a82f" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>LET ME TALK MA SHIT</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/4OdIvZBRfzeZROBIzusuB7?si=8c6e5c6d695e418f" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02122e45195d1c485c5a346f1e" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>kn1febaby - Ws (feat. Josen)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4tv5mcKiigYUapWtKnyogk?si=91d2d1399d524a2a" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e025ad0e0449083c7742631cb6e" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Stereo Love (feat. POPSTARBILLS & Braxton Knight)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/7yPCRmYRSMRH8t9PWYwmVl?si=4daabab6d0ba49d2" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02c97cbb4228fbb8f26e280692" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>NEVABORIN</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/37xwlBk3yPC8LaOOXqAJfj?si=7e64514ecef54653" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e029e7e6b65a5da57ae693d98fb" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Denim</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0w0XaSzg6guErOaNYnWe2N?si=f490385c56454674" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02fe0561e69c589720802b8473" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>4INDALEAN</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3VqDffTwpefPHuOdwvXLFP?si=5cdbc3b54a2b425d" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0225ef948861bf406a3a11c158" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>HowDaFuq (HellscapeMageekerz)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6PrLvnVyoKDzZHC4MTPhTh?si=e0ec066871764ece" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02f501f6dd5bc68e115d93f284" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>PUSH and KICK</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/2vkqPaPHiaRiEmlrtkARQj?si=15c26ec165154af2" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0274ce8b14387117ac4138c364" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>REROCK. - HOP OUT (feat. Josen)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2l7xyI60wvKJ3MDsgb2b1g?si=ea96d24a65884211" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e022531c90e211f2a6e5ed03548" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>MOCKINGBIRD ALICE VIP (w/ Alice333)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2UmC0zLnZaYkLBLvMnje9o?si=a9e0371d67a94b6b" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e029fd5e4a6e514f26419e1176f" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>OG BOBBY JOSEN FREESTYLE</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/7DUkhGfjlgI3hdGlgo1Mdy?si=0b0a91d3ac024919" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0280cd1c58a60d0d8b5da86865" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>TWINGLOCK</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/21G2zLAZzqUkDcEGCa97JA?si=9187c47ee5e040ab" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e027be365ad738e15f43c196b4c" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>SCRAPINDAPOT HARAMBE TRIBUTE</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1sKxEQBxKiay6QRzyh6HzA?si=4f01252c51774818" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02a7cb8a4fc3e1d4a65ec2b008" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>KICKINHEROUT</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/album/08m5P39GJCDzJftD4xjX7C?si=YJGk3w6MRdipMXYtzZvMVg" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e026b304c51b5d0baa70b2f05d1" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>PercyInMySystem</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6n1QNKGLmgszUSzKe0MPva?si=d9c849eecb014d7d" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e026a299479971076f09fc73743" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>DaPack!</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4fcv2pOHkz3Kva8aUdnPAu?si=32811b3dddd24855" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02fc8a0535975f4d89b8826781" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>BACKHOME FREESTYLE</strong><br/>
              </p>
            </a>
          </div>

        {/* <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5gHRrProqa67DAl8M7ZfbU?si=002fd599777d4625" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02197fd06ada659e5454f7815e" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Lolipop!</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2kitWuYaqqWQmuDOSyskhp?si=ed2e5ac5ef004b12" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02a5ce105e153ce05226a87482" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>LICKINDASTREET</strong><br/>
              </p>
            </a>
          </div> */}

        {/* <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0XyYlzIbdc4Zv4kTAzGJGE?si=8ca3b8edea184380" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0227c97c1d8ba39083ce748d95" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>FRIDAYNIGHT</strong><br/>
              </p>
            </a>
          </div> */}

        {/* <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/7En6dU8HccSmQrhIgC9UjJ?si=a105ff71f92d4b46" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02c67eb52145b87d42a3382402" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>DEMONONTIME</strong><br/>
              </p>
            </a>
          </div> */}

        {/* <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6xGkJqHiAxefRRic1RiAh0?si=df103940b731450e" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02affc04f5cf05d282392f5296" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>BITCHIMONGOIMARIDE4DATEAM</strong><br/>
              </p>
            </a>
          </div> */}

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3Vj19eUfsySRcu5Q3GEogq?si=b130ecf862f14bf4" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0215dceaa4449ad6553fbf136a" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Wraith</strong><br/>
              </p>
            </a>
          </div>

        {/* <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5e2GLu0U4AUkOR5Euy04G8?si=9c7fba27feb642d2" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0225a06f43113a39c8ac39782e" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>VISA</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/54E08ZEBT3WsejKLux7JYq?si=1baea9c7217d4592" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e020e11f456d0f65500098e78a4" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>RACKSRACKSRACKS</strong><br/>
              </p>
            </a>
          </div> */}

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4h1gxak4tV9YPSFi6mvEV3?si=dc682d6493bb4f7f" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e022a05d7cf62d3e9797c2e80a7" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>TRAPINDAMAIL</strong><br/>
              </p>
            </a>
          </div>

          {/* <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/79B4b8g0gGD15G8ISNwblc?si=747019c0081647c4" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02410e04744b89fd7912fce588" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>MurdazAndCrime</strong><br/>
              </p>
            </a>
          </div> */}

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2CPXylv11MpBi7Cpa2vJ94?si=3406f137a14748df" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02cdeb6b5e8099d4ede3850bf8" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>GLOCKY</strong><br/>
              </p>
            </a>
          </div>

          {/* <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0ThnwQ3tOfeZogLfg8eqy6?si=57c46194a355455e" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02454ba16eed3f02511ea1a147" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>FUCKINWITME</strong><br/>
              </p>
            </a>
          </div> */}

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4Qlw9Ph2rZ9m9V5kqlDkaS?si=1b193d723f7d4996" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0210195604a5a4dd5cedfef140" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>CallMyPhone</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3xT6cZwYzpUvumyJig9B1K?si=52a2b0bd75c246c8" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02497db90042c6ae724625e67f" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Air it out</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/fuck-again-w-kawaii-ry-prod-firemane-hellscape" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-yh43EzxgAXBpkzYy-0RVz1A-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Fuck Again (feat. Kawaii Ry)</strong><br/>
                (prod. Firemane)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/7GESdSsY3Buq9zuKa7gnTK?si=4b16c5efe24549d3" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02661a8cf335824d47685a0f49" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>REROCK. - PICK A SIDE (feat. Josen)</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/3k9r90ESy0oo0q8hnLENnz?si=d1172bd3c274409b" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0282c7f0beffc4717784cabc53" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>DamienPRIE$T - New York Flex (feat. Josen)</strong><br/>
                (prod. 730HAHAH)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/47oJ5zYZQCVdz6fxMsSazf?si=24a40317e731455f" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0209cd92204db6799df2dc7b09" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Miami Dave - Mobb (feat. Josen)</strong><br/>
              </p>
            </a>
          </div>          

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/drill-la-drill-intro-album" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-sSsPf8mp1dbUConC-10EJAg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Drill La Drill (Intro)</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/hollabackboy-prod-apt-9-1?in=liljosen/sets/drill-la-drill" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-sSsPf8mp1dbUConC-10EJAg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Da Aki Way</strong><br/>
                (prod. ljstnn)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/hollabackboy-prod-apt-9" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-sSsPf8mp1dbUConC-10EJAg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>HollabackBoy</strong><br/>
                (prod. Apartment9)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/ijustwannadrill-yungskrrt?in=liljosen/sets/drill-la-drill" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-sSsPf8mp1dbUConC-10EJAg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>IJustWannaDrill</strong><br/>
                (prod. Yung Skrrt & Taylor Morgan)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/ocarina-of-drill-prod?in=liljosen/sets/drill-la-drill" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-sSsPf8mp1dbUConC-10EJAg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Ocarina of Drill</strong><br/>
                (prod. Bleachh)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/drill-al-pastor-prod-tonto?in=liljosen/sets/drill-la-drill" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-sSsPf8mp1dbUConC-10EJAg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Drill Al Pastor</strong><br/>
                (prod. Tonto)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/i-h8-xmas-prod-rich-illuminati?in=liljosen/sets/drill-la-drill" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-sSsPf8mp1dbUConC-10EJAg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>i h8 Xmas</strong><br/>
                (prod. Rich Illuminati)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/8-drill-in-kiyoko-prod-dani?in=liljosen/sets/drill-la-drill" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-sSsPf8mp1dbUConC-10EJAg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Drill In Kiyoko</strong><br/>
                (prod. Dani Kiyoko)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/rizz-carlton-prod-heikadog?in=liljosen/sets/drill-la-drill" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-sSsPf8mp1dbUConC-10EJAg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Rizz Carlton</strong><br/>
                (prod. Heikadog)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/itstime2drill-prod-rich?in=liljosen/sets/drill-la-drill" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-sSsPf8mp1dbUConC-10EJAg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>ItsTime2Drill</strong><br/>
                (prod. Rich Illuminati)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/7BWuJJD9fvbpqQ8HRTePPj?si=7ec43658dba6437a" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273200c87078b070d6ac16a2bdc" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Drill La Drill (Intro)</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/hollabackboy-prod-apt-9-1?in=liljosen/sets/drill-la-drill" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-sSsPf8mp1dbUConC-10EJAg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Da Aki Way</strong><br/>
                (prod. ljstnn)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/hollabackboy-prod-apt-9" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-sSsPf8mp1dbUConC-10EJAg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>HollabackBoy</strong><br/>
                (prod. Apartment9)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/ijustwannadrill-yungskrrt?in=liljosen/sets/drill-la-drill" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-sSsPf8mp1dbUConC-10EJAg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>IJustWannaDrill</strong><br/>
                (prod. Yung Skrrt & Taylor Morgan)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/ocarina-of-drill-prod?in=liljosen/sets/drill-la-drill" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-sSsPf8mp1dbUConC-10EJAg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Ocarina of Drill</strong><br/>
                (prod. Bleachh)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/drill-al-pastor-prod-tonto?in=liljosen/sets/drill-la-drill" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-sSsPf8mp1dbUConC-10EJAg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Drill Al Pastor</strong><br/>
                (prod. Tonto)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/i-h8-xmas-prod-rich-illuminati?in=liljosen/sets/drill-la-drill" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-sSsPf8mp1dbUConC-10EJAg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>i h8 Xmas</strong><br/>
                (prod. Rich Illuminati)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/8-drill-in-kiyoko-prod-dani?in=liljosen/sets/drill-la-drill" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-sSsPf8mp1dbUConC-10EJAg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Drill In Kiyoko</strong><br/>
                (prod. Dani Kiyoko)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/rizz-carlton-prod-heikadog?in=liljosen/sets/drill-la-drill" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-sSsPf8mp1dbUConC-10EJAg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Rizz Carlton</strong><br/>
                (prod. Heikadog)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/itstime2drill-prod-rich?in=liljosen/sets/drill-la-drill" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-sSsPf8mp1dbUConC-10EJAg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>ItsTime2Drill</strong><br/>
                (prod. Rich Illuminati)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/7BWuJJD9fvbpqQ8HRTePPj?si=7ec43658dba6437a" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273200c87078b070d6ac16a2bdc" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Heems - Take Me (The Heights) (feat. Josen)</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/lolipop-prod-tonto" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-eG5y9Tg0XSqYe9QV-8jK1JQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>LOLLIPOP</strong><br/>
                (prod. TONTO)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/leavin-em-stuck-w-rerockraps" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-XWGEXOZGAA4d0KhN-DBYCUQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>LEAVIN EM STUCK' w/ REROCK!</strong><br/>
                (prod. REROCK / mashup by Geist)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/visa-prod-leovisa" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-wgyCob9yoY8t211z-uVZwMQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>VISA</strong><br/>
                (prod. LEOVISA)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/bigbillsondeck/twotimes" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-qaQc4G2G0Ro9Csfv-7xkavQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>POPSTARBILLS - TWO TIMES (feat. Josen & Zazbourne)</strong><br/>
              </p>
            </a>
          </div>          

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/bitchimongoimmaride4dateam" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-cNgKzGzcWsWl0Cyq-wZi9zg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>BITCHIMONGOIMMARIDE4DATEAM</strong><br/>
                (prod. SODROVE)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/done-died-w-jackie-platinum" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-rLd37yeBxMh3DJZz-TW35LQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>DONE!DIED! (feat. Jackie Platinum)</strong><br/>
                (prod. notamachine, Antar, OBMUS1C)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/dead2finesse/slum-josen-finessley" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-PlBAeeyl9CtAoHzi-vkrnxw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Finessley - Slum (feat. Josen)</strong><br/>
              </p>
            </a>
          </div>           

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/up-that-score-prod-leo" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-ayqtVbB720wA81Jy-3uR8og-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>UP!THAT!SCORE!</strong><br/>
                (prod. Leo)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/final-josen-prod-snake-mixed" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-rEyTQxOLQoxWYufg-ip6Zug-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>BITCH!YOU!A!DUB!</strong><br/>
                (prod. Snake)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/mockingbird-prod-daria-st" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-CarFD2NJ42gNIEXz-cJk87Q-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>MOCKINGBIRD!</strong><br/>
                (prod. Daria St. Clair)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/dyin-2-live-prod-swedistan" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-CarFD2NJ42gNIEXz-cJk87Q-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>DYIN 2 LIVE!</strong><br/>
                (prod. Swedistan)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/capture-the-moment-w-jackie" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-CarFD2NJ42gNIEXz-cJk87Q-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>CAPTURE THE MOMENT! (feat. Jackie Platinum & POPSTARBILLS)</strong><br/>
                (prod. Leo)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/4-what-prod-leo-x-remghost" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-CarFD2NJ42gNIEXz-cJk87Q-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>4 WHAT!</strong><br/>
                (prod. Leo, Remghost)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/m8b-zazbourne-prod-leo-x" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-CarFD2NJ42gNIEXz-cJk87Q-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>M8B! (feat. Zazbourne)</strong><br/>
                (prod. Leo, Remghost)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/g6-prod-leo" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-CarFD2NJ42gNIEXz-cJk87Q-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>G6!</strong><br/>
                (prod. Leo)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/klassyofficial/stix" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-ccUlVePvQBUUS1zV-NsZCpw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Klassy - STIX (feat. Josen)</strong><br/>
                (prod. Cranky)
              </p>
            </a>
          </div>  

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/line-em-prod-leo-mashup-by" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-h6iX3upFAEBaSHZ2-yAA1zA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>LINE EM!!</strong><br/>
                (prod. Leo) (Mashup by Geist)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/neverforgot-prod-leo-x" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-HNFUPNXTMbwYM33V-08c1bg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>NEVERFORGOT!!</strong><br/>
                (prod. Leo, sereN1ty)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/hellscapedigital/josen-cooj-prod-notamachine-hsd-exclusive" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-tdFV2ZdrsTjcq4Ia-JUzzIQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>COOJ!</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>          

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/fridaynight-prod-remghost" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27378e4bb414145546f8d13bf1d" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Friday Night</strong><br/>
                (prod. Remghost)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/za-official-zaza-anthem" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-EqblQymbFdYMunkr-8RYOIw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>ZA</strong><br/>
                (prod. TF)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/fuckinwitme-prod-leoxremghost" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-wDLKNWotkbyYtwmK-MVJZdw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>FUCKINWITME </strong><br/>
                (prod. Leo, Remghost)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/bigslime-w-popstarbills" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-VzwpyjjW5K2WYYDQ-ls8gHA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>#BIGSLiME (feat. POPSTARBILLS)</strong><br/>
                (prod. REDLUKE)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/racksracksracks-prodleo" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-2j3mxhvN0dsJbt6R-3mTTzA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>RACKSRACKSRACKS</strong><br/>
                (prod. Leo)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/demonontime-darastclair-hurenpopdemon" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-bS4S9y3d1LYH88Jl-9JuCmA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>DEMONONTIME!</strong><br/>
                (prod. Daria St. Clair)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/wristmotion-prodgeeohhs" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-6mad11GzwDDmvdqy-h64wFA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>WRISTMOTION!</strong><br/>
                (prod. Geeohhs)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/30W3dRFY5TTds4GC6UpySG?si=f05370a332eb4c73" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b2737541697374c32f7842d216d9" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Don Da Menace - Digital Age (feat. Josen)</strong><br/>
              </p>
            </a>
          </div>           

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3K0dqoIzSaDrKTgorOu8wy?si=8de57d6892d24ab9" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273b45491df9495f15b69dc7beb" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>WELCOME2JOSENWORLD</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3myHA6nWqIFQDG3Cz02MXd?si=2ca03c2999a64e27" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273b45491df9495f15b69dc7beb" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>DILLARY DUFF</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/06Clvzd4bpxTsOz7mEIB29?si=b7253e986d9841df" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273b45491df9495f15b69dc7beb" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>RACKITUP</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0dGVXUm13q78SOTjI0O1wj?si=401babd2c6fa4228" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273b45491df9495f15b69dc7beb" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>DA WORLD</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1wMLj1crWTIAuKkz8QXKPN?si=7ee751a2a2eb4602" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273b45491df9495f15b69dc7beb" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>GLOCKINMYJEANS</strong><br/>
                (prod. Baredex)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1t3s7pdd8W6GfGPbTFQR4B?si=33c3d04923ea4841" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273b45491df9495f15b69dc7beb" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>WIN</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/bigbillsondeck/yerrr-ft-josen-kasper-gem-prod" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-NNsIBEs2NVkhVgeh-YRYNBw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>POPSTARBILLS - YERRR (feat. Josen & Kasper Gem)</strong><br/>
                (prod. POPSTARBILLS & Redluke)
              </p>
            </a>
          </div>           

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/onmyown-supremekame" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-8P2nyyBDyswvygyq-pBqCUQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>ONMYOWN!</strong><br/>
                (prod. SUPREMEKAME)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/got-it-w-austinskinner-prod" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-cqwuDdrL9KdzoKo0-fdWAtw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>GOT IT! (feat. Austin Skinner)</strong><br/>
                (prod. Crayons, Tannr)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/essence-officialtoju" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-5tJN6maQqFAgqqWp-ecwX2w-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>ESSENCE!</strong><br/>
                (prod. OFFICIALTOJU)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/752xtJbY3NKs3E25WjgxYb?si=58b99050faf347b5" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02fc6c565454276a1d56745d30" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Miami Dave - GABAGOOL (feat. Josen)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/just-bars-w-natenumbaeight" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-dXamAIx2f7FPHp4y-C1SfDg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>JUST BARS (feat. NateNumbaEight & Ugly Tomorrow)</strong><br/>
                (prod. DJSHIP)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/cantyoutell-djship" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-rPamRler5LbvUQ0n-GK9fAg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>CANTYOUTELL</strong><br/>
                (prod. DJSHIP)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/aintdoneyet-teddycxfrxstbite" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-63PKzqQr5LmDXsk6-yQ1vmQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>AINTDONEYET!!</strong><br/>
                (prod. TEDDYC, FRXSTBITE)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/obama-runtz-haver-24khris" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-9SQGAnjA3JCH6Tj0-BQ2LJQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>#OBAMA#RUNTZ#HAVER</strong><br/>
                (prod. 24khris)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/regardless-prod-crayons" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-xPA1ItH3IHl6EaNT-v7c9sA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>REGARDLESS</strong><br/>
                (prod. Crayons)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/aliciakeyz-wrry" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-dTXFJ3gu1sJe8h8V-VgzNog-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>ALICIAKEYZ</strong><br/>
                (prod. WRRY)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/liccindastreet-prod-by-free" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-pQ5oW1QlAvLghF6J-3CUqsQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>LICCINDASTREET</strong><br/>
                (prod. Free Diesel)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/kevinsavior/pop-rocks-popstarbills" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-Zum2kbeU4JprzXcw-I5SLIw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kevin Hilfiger - poprocks (feat. POPSTARBILLS & Josen)</strong><br/>
                (prod. shy)
              </p>
            </a>
          </div>          

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/heart-of-da-city-prod-snake" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-DwAgf7j3qaAdmOZQ-JqHYBA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>HEART OF DA CITY</strong><br/>
                (prod. Snake)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/onmyway-prod-nitetime" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-xyOzeHuXJ0dByTj7-Y1kECw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>ONMYWAY!</strong><br/>
                (prod. NITETIME)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/peglegfreestyle-w" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-fXDPVsh852KBz7Fs-Csz9Ew-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>PEGLEG FREESTYLE (feat. NateNumbaEight, Blackwinterwells, Kevin Hilfiger, Jackie Platinum, Midwxst, Goldenuzis)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4PBndsHhWOJpsu2HytPUZU?si=812c0dbf867b4f9c" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-76buDPGEZQzoF4Ab-mImSzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Alchemy (feat. OHMGKARMA)</strong><br/>
                (prod. SHOKI, OHMGKARMA)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4PBndsHhWOJpsu2HytPUZU?si=812c0dbf867b4f9c" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-ZS96h0z9b9m6Q7c4-L2dQhA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>2 For 1 (Part 2)</strong><br/>
                (prod. ADDIN, FRANKWHITE)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4PBndsHhWOJpsu2HytPUZU?si=812c0dbf867b4f9c" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-P9OiwXQ7PIFFckMt-S16WcA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Spaceship (feat. POPSTARBILLS)</strong><br/>
                (prod. AMADXUS)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/custom-made-w-jackie-platinum" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-YbFMRaBZrjxSJDP8-7gqrGA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>CUSTOM MADE (feat. Jackie Platinum, Kevin Hilfiger, Boofbby)</strong><br/>
                (prod. Rio Leyva)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/coo-3" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-m5VD8RsrwGrV370Q-D5yNZg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>KOKAINE*DANCEMIX* (feat. POPSTARBILLS)</strong><br/>
                (prod. DEATHNOTES)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4F5amTpnwRgq5nqydvY46J?si=1f950802b1e54e51" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-JcyVAxK0cSLsGmxz-UijgFg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>MISS ME (feat. POPSTARBILLS)</strong><br/>
                (prod. BLACKWINTERWELLS)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/2myhead" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-OIZaWyK5y9jvo0Ra-zpl0ig-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>2 MY HEAD (feat. POPSTARBILLS, Braxton Knight)</strong><br/>
                (prod. DEATHNOTES)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/7Jle8lok5iqWobTCXaQNuQ?si=cb8d0d00f66840b6" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b2739ec0062d4390759900ce2802" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Cybergirl (feat. POPSTARBILLS)</strong><br/>
                (prod. ASTERHECC)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/40ballbigsteppa-prod-goodnightniko" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-LU9VDEA4OYwCOUrW-QSlopg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>40BALLBIGSTEPPA</strong><br/>
                (prod. goodnightniko)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3rinI5ucmExGNngBRHpeME?si=97c053d48e2b45dd" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b2739ec0062d4390759900ce2802" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Wait On Me (feat. POPSTARBILLS)</strong><br/>
                (prod. NOT HOTI)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/7fGia71x5LS3x7FHjvs1em?si=7aecfc252a034cb3" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b2739ec0062d4390759900ce2802" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Lotta Demonz</strong><br/>
                (prod. DJSHIP)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/teardropdigital/josen-x-bill-mochi-pack-prod-brwnworld-teardrop-exclusive" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000653041048-yxgodj-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Josen & POPSTARBILLS - MOCHI PACK</strong><br/>
                (prod. Brwnworld)
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/push-on-me-prod-dcxshy" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000647639368-gk95ok-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>PUSH ON ME</strong><br/>
                (prod. DCXSHY)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/murdazcrimeprodamadxus" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-XhOKimxWzintscuS-yyvdEA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>MURDAZ&CRIME!</strong><br/>
                (prod. AMADXUS)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/40rounddrum-prod-dontsleep-x-ryderjohnson" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000599190485-47lvu4-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>40ROUNDDRUM!</strong><br/>
                (prod. Dontsleep, RyderJohnson)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/3zXI0uxNFIX8HYrcOXRYoB?si=eb8fe46e818e460f" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e026f387f82b8dc8e8078b537d8" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Don Da Menace - Digital Age (feat. Josen)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/josen-no-order-14" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000576193349-p07feo-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>FUCKITUPYEAH!</strong><br/>
                (prod. ProdRagu)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/dancers-w-david-shawty" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000557505360-32hcab-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Dancers! (feat. David Shawty)</strong><br/>
                (prod. Trapphones)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/outside-prod-leanysl" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000541434375-0k9bab-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>OUTSIDE!!</strong><br/>
                (prod. LeanYSL)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/somuchtolivefor-prod-killjustin-x-drakobill" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000537038436-khrcf0-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>SoMuchToLiveFor..</strong><br/>
                (prod. KillJustin, DrakoBill$)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/nostalgiacomo/no-surprises-feat-teven-cannon" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000534003885-8ohgxm-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Nostalgiac - No Surprises (feat. $teven Cannon, Lil Xelly & Josen)</strong><br/>
              </p>
            </a>
          </div>           

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/main-bitch-prod-drako-x-yeoj" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000526010073-azzvmg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Main Bitch!</strong><br/>
                (prod. DrakoBill$, Yeoj)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/knowtheymad-prod-wrry" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000516309666-y7p0ha-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>KNOWTHEYMAD!</strong><br/>
                (prod. Wrry)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/finger-prod-dontsleep" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000512746971-25wwq9-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Finger!</strong><br/>
                (prod. Dontsleep)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0p6cTC0RTPYNflvD0qhIia?si=f319add4ceb14538" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000501145698-9djj28-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Right Now (feat. POPSTARBILLS)</strong><br/>
                (prod. Hoodwtch)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/ballin-nba-feat-yung-tuda-prod" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000501145698-9djj28-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Ballin NBA! (feat. Yung Tuda)</strong><br/>
                (prod. Deceased, 1chai)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/mud-anthem-feat-tommy-ice" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000501145698-9djj28-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Mud Anthem! (feat. Tommy Ice)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/wit-it-feat-endoh-prod" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000501145698-9djj28-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Wit It! (feat. Endoh)</strong><br/>
                (prod. Endoh)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/veggies-feat-yungster-jack" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000501145698-9djj28-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Veggies! (feat. Yungster Jack)</strong><br/>
                (prod. Lukrative)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/weekend-feat-soljay-yeat-prod" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000501145698-9djj28-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Weekend! (feat. Soljay & Yeat)</strong><br/>
                (prod. 4AM)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/crystals-feat-hellfiger-prod" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000501145698-9djj28-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Crystals (feat. Hellfiger)</strong><br/>
                (prod. FrxstBite)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/vital-feat-ghostie" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000501145698-9djj28-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Vital! (feat. Ghostie & LuveLovesYou)</strong><br/>
                (prod. Ghostie)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/bleedin-feat-bill-prod-snoozed" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000501145698-9djj28-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Bleedin (feat. POPSTARBILLS)</strong><br/>
                (prod. Snoozed)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/bank-feat-kankan-prod-geeohs" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000501145698-9djj28-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Bank (feat. KanKan)</strong><br/>
                (prod. Rican Havoc, Geeohs)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/everytime-feat-jvles-prod" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000501145698-9djj28-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Everytime! (feat. JVLES)</strong><br/>
                (prod. Dontsleep, CashCache)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/designer-drugs-feat-yung-tuda" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000501145698-9djj28-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Designer Drugs! (feat. Yung Tuda)</strong><br/>
                (prod. Deceased, Falsecut)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/no-code-feat-texako-prod" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000501145698-9djj28-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>No Code! (feat. Texako)</strong><br/>
                (prod. Ninethluke)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/walk-in-feat-gojibeanbryant" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000501145698-9djj28-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Walk In (feat. GojiBeanBryant)</strong><br/>
                (prod. Mozi)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/sk8board-p-w-da-bape-prod-wildcardt-josennnnn" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000484401144-helbd5-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>SK8BOARD P W/ DA BAPE!!</strong><br/>
                (prod. Wildcardt)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/ihateyeoj/today-feat-jo-en-yeoj" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000483306537-pa4tb4-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Yeoj - Today (feat. Josen)</strong><br/>
              </p>
            </a>
          </div>             

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2zQ1jGFg247ZSfaYFVfnN2?si=8fef36adc34743f7" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000501146259-o26h0a-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>MUDPISS (feat. Lil Turbo)</strong><br/>
                (prod. Brwnworld)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/friday" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000466907016-o0s4q7-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>FRIDAY!</strong><br/>
                (prod. Leanbwoy)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/packrunning-prod-endoh" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000466170471-43zuvs-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Packrunning!</strong><br/>
                (prod. Endoh)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/josen-no-order" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000463265079-s1xsta-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>TRIPPIN!</strong><br/>
                (prod. Brwnworld)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/wristwatch-prod-brwnworld" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000455677299-r9zawt-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>WRISTWATCH!</strong><br/>
                (prod. Brwnworld)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/facts-prod-karmarhythm-drakobill-josennnnn" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000445748022-jy1hvm-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>FACTS!</strong><br/>
                (prod. KarmaRhythm, DrakoBill$)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/addicted-prod-deceased-x-quali" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000440630472-h8ofir-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Addicted!</strong><br/>
                (prod. Deceased, Quali)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/inthatbitch-deceasedxcryjng" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000420070701-b5dn87-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>INTHATBITCH!</strong><br/>
                (prod. Deceased, Cryjng)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/nasdaq-prod-shoki" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000412996878-je1af7-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Nasdaq!</strong><br/>
                (prod. Shoki)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/all-in-w-kevin-kazi-wilkjayy" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000397233669-txmab3-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>All In! (feat. Kevin Kazi & Wilkjayy)</strong><br/>
                (prod. Trapphones)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/nascar-prod-traplordcami-x-drumma" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000386130333-pz1n0n-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Nascar!</strong><br/>
                (prod. Traplordcami, Drumma)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/scene-prod-geekhead808-x-jakesand-josennnnn" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000377157543-3cddg2-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Scene!</strong><br/>
                (prod. GeekHead, Jakesand)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/josen-ft-kap" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000373939818-1196xn-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>199X (feat. Loudpack Kap)</strong><br/>
                (prod. Trapphones)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/heart" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000370762158-sp69t0-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Heart!</strong><br/>
                (prod. Gosuto, Gren8)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/magic-prod-negative" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000366876006-arybys-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Magic!</strong><br/>
                (prod. Negative)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/globetrottin-prod-geekhead-x-lifted" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000353148600-uycy9v-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Globetrottin!</strong><br/>
                (prod. GeekHead)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/heater-on-me-prod-scroll" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000327477228-py56gg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Heater On Me</strong><br/>
                (prod. Scroll)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/roadrunner-interlude-prod" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000327477228-py56gg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Roadrunner (Interlude)</strong><br/>
                (prod. Institute)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/cocaina-ft-yeat-prod-yung" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000327477228-py56gg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Cocaína (feat. Yeat)</strong><br/>
                (prod. Yung Castor)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/my-phone-prod-geekhead" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000327477228-py56gg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>My Phone</strong><br/>
                (prod. GeekHead)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/in-miami-prod-vision4k" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000327477228-py56gg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>In Miami</strong><br/>
                (prod. Vision4k)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/im-a-hottie-freestyle-prod-scroll" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000327477228-py56gg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Hottie</strong><br/>
                (prod. qyns)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/helmut-lang-prod-vision4k" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000295783926-e01wli-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Helmut Lang</strong><br/>
                (prod. Vision4k)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/uber-prod-vision4k" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000295783926-e01wli-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Uber</strong><br/>
                (prod. Vision4k)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/comin-back-intro-prod-vision4k" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000295783926-e01wli-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Comin' Back (Intro)</strong><br/>
                (prod. Vision4k)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/iceprod-vision4k" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000295783926-e01wli-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Ice</strong><br/>
                (prod. Vision4k)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/riri-on-my-wrist-prod-king-cvsey" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000208363563-3qr7jt-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Riri On My Wrist</strong><br/>
                (prod. King Cvsey)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/in-da-whip-lowcliqueboys-exclusive-prod-seithen-colin-ezeli" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000197991699-t54j0k-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>IN DA WHIP</strong><br/>
                (prod. SEITHÈN, COLIN EZELI)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/50-glocc-prod-mozi" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000220289371-821yh6-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>50 GLOCC</strong><br/>
                (prod. Mozi)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/mudaico/braxton-knight-ape-escape-ft-josen-prod-hellasketchy" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000187454722-4c3mrw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Braxton Knight - Ape Escape (feat. Josen)</strong><br/>
                (prod. hellasketchy [RIP])
              </p>
            </a>
          </div>  

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/whip-the-bih-prof-by-free-diesel" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000160636617-45670y-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Whip the Bih</strong><br/>
                (prod. Free Diesel)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/keyana-tisha-prod-by-rafael-medina" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000151075739-zkfn4c-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Keyana & Tisha</strong><br/>
                (prod. RafaeL Medina)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/liljosen/2-for-1-prod-rhandy-svg" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000150810738-5pikp6-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>2 For 1</strong><br/>
                (prod. Randy SVG)
              </p>
            </a>
          </div>

        </div>
      </>
    );
  };
  export default JosenAllReleasesStatic;